export default __webpack_public_path__ + "static/SustainableFutures-IntroLetter-v2-bea4dd03b4eaced52597e40e1c91c4c1.pdf";